import React from 'react';
import { Divider, Space, Switch, Tag } from '@bedrock/components';
import classNames from 'classnames/bind';
import styles from './index.less';

const cx = classNames.bind(styles);

interface ReportedSwitchProps {
  isReported: boolean;
  onIsReportedChange: (checked: boolean) => void;
  count: number;
  view?: boolean;
}

export const ReportedSwitch: React.FC<ReportedSwitchProps> = ({
  isReported,
  onIsReportedChange,
  count,
  view = false,
}) => {
  if (view) {
    return <Tag size="small" color={count > 0 ? 'green' : 'grey' as any} text={
      count > 0 ? `提报${count}` : '不提报'
    } />;
  }
  return (
    <>
      <Divider type="vertical" />
      <Space className={cx('reported-switch')} size={24}>
        <span className={cx('text')} onClick={(e) => e.stopPropagation()}>
          是否提报:  <Switch
            size="medium"
            checked={isReported}
            onChange={onIsReportedChange}
            labelOn="提报"
            labelOff="不提报"
          />
        </span>
        {isReported && (
          <span className={cx('text')}>
            已提报达人：<span className={cx('text-success')}>{count}</span>
          </span>
        )}
      </Space>
    </>
    
  );
};
